import { useCallback } from 'react'
import { useEnv } from '~/env'

import { useRedirectBackUrlToReserveInput } from '~/navigation'

export function useYahooConnectUrl() {
  const env = useEnv()
  const redirectBackUrl = useRedirectBackUrlToReserveInput()
  return useCallback(() => {
    const encodedRedirectBackUrl = encodeURIComponent(redirectBackUrl)
    return `${
      env.MEMBER_ORIGIN
    }/member/oauth/yid?dest=${encodedRedirectBackUrl}&back=dest&nomailmatch=true&type=ikyu`
  }, [env, redirectBackUrl])
}

export function usePayPayConnectUrl() {
  const redirectBackUrl = useRedirectBackUrlToReserveInput()
  return useCallback(() => {
    const encodedRedirectBackUrl = encodeURIComponent(redirectBackUrl)
    return `https://paypay.yahoo.co.jp/balance?.done=${encodedRedirectBackUrl}&.bail=${encodedRedirectBackUrl}`
  }, [redirectBackUrl])
}

export function usePayPayAuthenticationUrl() {
  const redirectBackUrl = useRedirectBackUrlToReserveInput()
  return useCallback(() => {
    const encodedRedirectBackUrl = encodeURIComponent(redirectBackUrl)
    return `https://account.edit.yahoo.co.jp/verify_msn_pay2?src=ppext&.done=${encodedRedirectBackUrl}&.bail=${encodedRedirectBackUrl}`
  }, [redirectBackUrl])
}
